import {IRange} from "@pg-design/range-module";
import {IOption} from "@pg-design/select-module";
import {PreferencesSurveySource} from "@pg-rp/common-types";

import {HomeMatchFinancingPreference} from "../constants/preferences/home_match_preferences_values";
import {ConstructionEndDateType} from "../types/ConstructionEndDateType";
import {IHomeMatchSurveyApiRequest} from "../types/home_match_preferences";
import {
    HomeMatchPreferencesWizardParameterStep,
    HomeMatchPreferencesWizardStep,
    IHomeMatchPreferencesWizardSurvey
} from "./get_home_match_preferences_wizard_steps";
import {getHomeMatchRoomsPatch} from "./home_match_rooms_range";

export interface IHomeMatchPreferencesWizardSurveyForm {
    constructionEndDate: ConstructionEndDateType | null;
    financing: HomeMatchFinancingPreference | null;
    price: IRange<number>;
    regions: IOption<number>[];
    rooms: IRange<number | ""> | null;
}

export const getHomeMatchRegionIds = (regions: IOption<number>[]) =>
    regions.map((region) => region.value).filter((regionId): regionId is number => typeof regionId === "number");

/** A survey cannot be saved without a location, from a chip as well as from the full survey: an empty list would clear the saved one. */
export const hasHomeMatchRegion = (regions: IOption<number>[]) => getHomeMatchRegionIds(regions).length > 0;

export const getHomeMatchPricePatch = (price: {lower?: number; upper?: number | null} | null | undefined): IHomeMatchSurveyApiRequest["price"] => {
    const upper = price?.upper;

    if (typeof upper !== "number" || upper <= 0) return null;

    return {lower: price?.lower ?? 0, upper};
};

interface IGetHomeMatchPreferencesWizardStepPatchParams {
    constructionEndDate?: ConstructionEndDateType | null;
    financing: HomeMatchFinancingPreference | null;
    priceUpper?: number | null;
    regionOptions: IOption<number>[];
    rooms: IHomeMatchPreferencesWizardSurveyForm["rooms"];
    savedSurvey: IHomeMatchPreferencesWizardSurvey | null | undefined;
    source: PreferencesSurveySource;
    step: HomeMatchPreferencesWizardParameterStep;
}

export const getHomeMatchPreferencesWizardStepPatch = (params: IGetHomeMatchPreferencesWizardStepPatchParams): IHomeMatchSurveyApiRequest => {
    const {constructionEndDate = null, financing, priceUpper, regionOptions, rooms, savedSurvey, source, step} = params;
    const savedPrice = savedSurvey?.price ?? null;
    const savedRegions = savedSurvey?.regions ?? [];
    const savedRooms = savedSurvey?.rooms ?? null;
    const nextPrice = getHomeMatchPricePatch({lower: savedPrice?.lower, upper: priceUpper});
    const financingPreference = financing ?? undefined;

    if (step === HomeMatchPreferencesWizardStep.LOCATION) {
        return {
            price: savedPrice,
            regions: getHomeMatchRegionIds(regionOptions),
            rooms: savedRooms,
            source
        };
    }

    if (step === HomeMatchPreferencesWizardStep.BUDGET) {
        return {
            ...(financingPreference ? {financing_preference: financingPreference} : {}),
            price: nextPrice,
            regions: savedRegions,
            rooms: savedRooms,
            source
        };
    }

    if (step === HomeMatchPreferencesWizardStep.COMPLETION_DATE) {
        return {
            construction_end_date: constructionEndDate,
            price: savedPrice,
            regions: savedRegions,
            rooms: savedRooms,
            source
        };
    }

    return {
        price: savedPrice,
        regions: savedRegions,
        rooms: getHomeMatchRoomsPatch(rooms),
        source
    };
};

export const canContinueHomeMatchPreferencesWizardStep = (step: HomeMatchPreferencesWizardParameterStep, form: IHomeMatchPreferencesWizardSurveyForm) => {
    if (step === HomeMatchPreferencesWizardStep.LOCATION) {
        return hasHomeMatchRegion(form.regions);
    }

    if (step === HomeMatchPreferencesWizardStep.BUDGET) {
        return getHomeMatchPricePatch(form.price) != null;
    }

    return true;
};
import {IRange} from "@pg-design/range-module";
import {IOption} from "@pg-design/select-module";
import {PreferencesSurveySource} from "@pg-rp/common-types";

import {HomeMatchFinancingPreference} from "../constants/preferences/home_match_preferences_values";
import {ConstructionEndDateType} from "../types/ConstructionEndDateType";
import {IHomeMatchSurveyApiRequest} from "../types/home_match_preferences";
import {
    HomeMatchPreferencesWizardParameterStep,
    HomeMatchPreferencesWizardStep,
    IHomeMatchPreferencesWizardSurvey
} from "./get_home_match_preferences_wizard_steps";
import {getHomeMatchRoomsPatch} from "./home_match_rooms_range";

export interface IHomeMatchPreferencesWizardSurveyForm {
    constructionEndDate: ConstructionEndDateType | null;
    financing: HomeMatchFinancingPreference | null;
    price: IRange<number>;
    regions: IOption<number>[];
    rooms: IRange<number | ""> | null;
}

export const getHomeMatchRegionIds = (regions: IOption<number>[]) =>
    regions.map((region) => region.value).filter((regionId): regionId is number => typeof regionId === "number");

/** A survey cannot be saved without a location, from a chip as well as from the full survey: an empty list would clear the saved one. */
export const hasHomeMatchRegion = (regions: IOption<number>[]) => getHomeMatchRegionIds(regions).length > 0;

export const getHomeMatchPricePatch = (price: {lower?: number; upper?: number | null} | null | undefined): IHomeMatchSurveyApiRequest["price"] => {
    const upper = price?.upper;

    if (typeof upper !== "number" || upper <= 0) return null;

    return {lower: price?.lower ?? 0, upper};
};

interface IGetHomeMatchPreferencesWizardStepPatchParams {
    constructionEndDate?: ConstructionEndDateType | null;
    financing: HomeMatchFinancingPreference | null;
    priceUpper?: number | null;
    regionOptions: IOption<number>[];
    rooms: IHomeMatchPreferencesWizardSurveyForm["rooms"];
    savedSurvey: IHomeMatchPreferencesWizardSurvey | null | undefined;
    source: PreferencesSurveySource;
    step: HomeMatchPreferencesWizardParameterStep;
}

export const getHomeMatchPreferencesWizardStepPatch = (params: IGetHomeMatchPreferencesWizardStepPatchParams): IHomeMatchSurveyApiRequest => {
    const {constructionEndDate = null, financing, priceUpper, regionOptions, rooms, savedSurvey, source, step} = params;
    const savedPrice = savedSurvey?.price ?? null;
    const savedRegions = savedSurvey?.regions ?? [];
    const savedRooms = savedSurvey?.rooms ?? null;
    const nextPrice = getHomeMatchPricePatch({lower: savedPrice?.lower, upper: priceUpper});
    const financingPreference = financing ?? undefined;

    if (step === HomeMatchPreferencesWizardStep.LOCATION) {
        return {
            price: savedPrice,
            regions: getHomeMatchRegionIds(regionOptions),
            rooms: savedRooms,
            source
        };
    }

    if (step === HomeMatchPreferencesWizardStep.BUDGET) {
        return {
            ...(financingPreference ? {financing_preference: financingPreference} : {}),
            price: nextPrice,
            regions: savedRegions,
            rooms: savedRooms,
            source
        };
    }

    if (step === HomeMatchPreferencesWizardStep.COMPLETION_DATE) {
        return {
            construction_end_date: constructionEndDate,
            price: savedPrice,
            regions: savedRegions,
            rooms: savedRooms,
            source
        };
    }

    return {
        price: savedPrice,
        regions: savedRegions,
        rooms: getHomeMatchRoomsPatch(rooms),
        source
    };
};

export const canContinueHomeMatchPreferencesWizardStep = (step: HomeMatchPreferencesWizardParameterStep, form: IHomeMatchPreferencesWizardSurveyForm) => {
    if (step === HomeMatchPreferencesWizardStep.LOCATION) {
        return hasHomeMatchRegion(form.regions);
    }

    if (step === HomeMatchPreferencesWizardStep.BUDGET) {
        return getHomeMatchPricePatch(form.price) != null;
    }

    return true;
};
